import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiGet } from "../lib/api";
import "./KabileSiralamalari.css";

interface LeaderAnswer {
  answerId: string;
  answerText: string;
  leaderUsername: string;
  leaderTP: number;
  totalKP: number;
  questionText: string;
  battleDate: string;
}

interface KabileRanking {
  kabileId: string;
  kabileName: string;
  kabileFlagUrl?: string;
  leaderAnswer: LeaderAnswer;
  totalMembers: number;
  totalTP: number;
}

export default function KabileSiralamalari() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [rankings, setRankings] = useState<KabileRanking[]>([]);

  useEffect(() => {
    loadRankings();
  }, []);

  const loadRankings = async () => {
    try {
      setLoading(true);
      const response = await apiGet<{ ok: true; rankings: KabileRanking[] }>(
        "/api/kabile/rankings"
      );
      setRankings(response.rankings);
    } catch (error) {
      console.error("Sıralamalar yüklenemedi:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="kabile-rankings-container">
        <div className="rankings-loading">
          <div className="loading-spinner"></div>
          <p>Sıralamalar yükleniyor...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="kabile-rankings-container">
      <div className="kabile-rankings-content">
        <header className="rankings-header">
          <button onClick={() => navigate("/savkabile")} className="back-btn">
            ← Geri
          </button>
          <h1 className="rankings-title">
            🏆 <span className="title-gradient">Kabile Sıralamaları</span>
          </h1>
          <p className="rankings-subtitle">
            Liderlerin cevaplarına verilen KP beğeni toplamı
          </p>
        </header>

        <main className="rankings-main">
          {rankings.length === 0 ? (
            <div className="no-rankings">
              <div className="no-rankings-icon">📊</div>
              <h3>Henüz Sıralama Yok</h3>
              <p>Liderler cevap paylaştıkça ve üyeler KP verdikçe sıralama oluşacak.</p>
            </div>
          ) : (
            <div className="rankings-list">
              {rankings.map((rank, index) => (
                <div 
                  key={rank.kabileId} 
                  className={`ranking-card rank-${index + 1}`}
                  onClick={() => navigate(`/savkabile/${rank.kabileId}`)}
                >
                  <div className="ranking-position">
                    {index < 3 ? (
                      <div className="position-badge">
                        {index === 0 && "🥇"}
                        {index === 1 && "🥈"}
                        {index === 2 && "🥉"}
                      </div>
                    ) : (
                      <div className="position-badge rank-number-box">
                        <span className="rank-number">{index + 1}</span>
                      </div>
                    )}
                  </div>

                  <div className="ranking-kabile-info">
                    {rank.kabileFlagUrl ? (
                      <img 
                        src={rank.kabileFlagUrl} 
                        alt={rank.kabileName} 
                        className="ranking-flag"
                      />
                    ) : (
                      <div className="ranking-flag-placeholder">🏛️</div>
                    )}
                    <div className="ranking-kabile-details">
                      <h3 className="ranking-kabile-name">{rank.kabileName}</h3>
                      <div className="kabile-stats">
                        <span className="stat">
                          <span className="stat-icon">👥</span>
                          {rank.totalMembers} üye
                        </span>
                        <span className="stat">
                          <span className="stat-icon">⚔️</span>
                          {rank.totalTP.toLocaleString()} TP
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="ranking-answer-section">
                    <div className="answer-header">
                      <span className="answer-label">Liderin Cevabı:</span>
                      <span className="answer-author">
                        👑 {rank.leaderAnswer.leaderUsername} ({rank.leaderAnswer.leaderTP} TP)
                      </span>
                    </div>
                    <div className="answer-question">
                      <strong>Soru:</strong> {rank.leaderAnswer.questionText}
                    </div>
                    <div className="answer-text">
                      {rank.leaderAnswer.answerText}
                    </div>
                    <div className="answer-meta">
                      <span className="answer-date">
                        📅 {new Date(rank.leaderAnswer.battleDate).toLocaleDateString('tr-TR')}
                      </span>
                    </div>
                  </div>

                  <div className="ranking-kp-section">
                    <div className="kp-badge">
                      <div className="kp-value">{rank.leaderAnswer.totalKP}</div>
                      <div className="kp-label">Toplam KP</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </main>
      </div>
    </div>
  );
}
